import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../Redux";
import { useHistory } from "react-router-dom";

import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Select from "../../../Components/Select";
import Input from "../../../Components/Input";
import DynamicTable from "../../../Components/DynamicTable";
import DynamicModal from "../../../Components/DynamicModal";
import moment from "moment";
import DateInput from "../../../Components/DateInput";
import ModelContainer from "../../../Components/ModelContainer";
import MultiSelect from "../../../Components/MultiSelect";
import TimeInput from "../../../Components/TimeInput";
import Checkbox from "../../../Components/Checkbox";
import { editMultiSelectOptions } from "../../../../helpers";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,
  MdFolder,
  MdFolderOpen,
  MdInsertDriveFile,
} from "react-icons/md";
import { parse } from "date-fns";

const NewPromotion = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const formType = useSelector(
    (state) => state?.settingReducer?.promo_data_form_type
  );

  const promotionsFormData = useSelector(
    (state) => state?.settingReducer?.promotionsFormData
  );
  const promotionEditData = useSelector(
    (state) => state?.settingReducer?.promotionEditData
  );

  const [selectedItemNum, setSelectedItemNum] = useState(0);
  useEffect(() => {
    dispatch(actions.getPromotionsFormData());
    return () => {
      dispatch(actions.saveEditPromotionData(null));
      dispatch(actions.savePromotionPeriod(null));
    };
  }, []);

  const promotionsFormSchema = yup.object({
    promotion_name: yup.string().required(),
    code: yup.string().required(),
    auto_apply: yup.string().required(),
    qualification_type: yup.string().required(),
    combo_allowed: yup.string().required(),
    allowed_within_group: yup.string().required(),
    loyalty_only_promotion: yup.string().required(),
    promotion_group_id: yup.string().required(),
    type: yup.string().required(),
    amount: yup.string().required(),
    status: yup.string().required(),
    approval_require: yup.string(),
  });
  const addFormDefaultValues = {
    promotion_name: "0",
    code: "0",
    auto_apply: "0",
    qualification_type: "0",
    combo_allowed: "0",
    allowed_within_group: "0",
    loyalty_only_promotion: "0",
    promotion_group_id: "0",
    type: "0",
    amount: "0",
    status: "0",
    approval_require: "0",
  };
  const editFormDefaultValues = {
    promotion_name: promotionEditData?.promotion_name,
    code: promotionEditData?.code,
    auto_apply: promotionEditData?.auto_apply,
    qualification_type: promotionEditData?.qualification_type,
    combo_allowed: promotionEditData?.combo_allowed,
    allowed_within_group: promotionEditData?.allowed_within_group,
    loyalty_only_promotion: promotionEditData?.loyalty_only_promotion,
    promotion_group_id: promotionEditData?.promotion_group_id,
    type: promotionEditData?.type,
    amount: promotionEditData?.amount,
    status: promotionEditData?.status,
    approval_require: promotionEditData?.approval_require,
  };
  useEffect(() => {
    if (formType === "edit") promotionsFormReset(editFormDefaultValues);
  }, [promotionEditData, formType]);
  const {
    register: promotionsFormRegister,
    formState: { errors: promotionsFormError },
    handleSubmit: promotionsFormSubmit,
    reset: promotionsFormReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(promotionsFormSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues:
      formType === "add" ? addFormDefaultValues : editFormDefaultValues,
  });

  function submitData(data) {
    console.log(data, formType === "edit", "ooooiiii");
    if (formType === "edit") {
      dispatch(
        actions.postEditPromotionData({
          id: promotionEditData?.id,
          ...data,
          historyFunc: history,
        })
      );
    } else {
      dispatch(actions.postAddPromotionData({ ...data, historyFunc: history }));
    }
  }
  // application Modal start

  const [deactivateInputs, setDeactivateInputs] = useState({
    combo_allowed: false,
    qualification_type: false,
    auto_apply: false,
  });

  // application Modal end

  // add promo Modal start
  const addPromoModalState = useSelector(
    (state) => state?.settingReducer?.add_promo_modal_state
  );
  const setAddPromoModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "add_promo_modal_state",
        modalState: state,
      })
    );
  // add promo Modal end

  // qualification Modal start
  const qualificationModalState = useSelector(
    (state) => state?.settingReducer?.qualification_modal_state
  );
  const setQualificationModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "qualification_modal_state",
        modalState: state,
      })
    );
  // add promo Modal end

  const [newPromotionGroupValue, setNewPromotionGroupValue] = useState(false);
  useEffect(() => {
    if (newPromotionGroupValue) {
      setValue(
        "promotion_group_id",
        promotionsFormData?.promotion_group[
          promotionsFormData?.promotion_group?.length - 1
        ]?.value
      );
      setNewPromotionGroupValue(false);
    }
  }, [promotionsFormData]);
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass my-4">
              <div class="row mx-0">
                <div class="row">
                  <h4 class="event-alert col-md-4">Promotion Details </h4>
                  <form
                    className="row mx-0 px-0 justify-content-between align-items-center"
                    onSubmit={promotionsFormSubmit(submitData)}
                  >
                    <div class="col-md-6">
                      <ul class="ingredient-info edit-shift">
                        <Input
                          label={"Promotion Name"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="promotion_name"
                        />
                        <Input
                          label={"Promotion Code"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="code"
                        />
                        <Select
                          label={"Auto Apply"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="auto_apply"
                          optionsArray={promotionsFormData?.yesno}
                          deactivate={deactivateInputs?.auto_apply}
                          onChange={(e) => {}}
                        />

                        <Select
                          label={"Qualification Type"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="qualification_type"
                          optionsArray={promotionsFormData?.qualification_type}
                          deactivate={deactivateInputs?.qualification_type}
                          onChange={(e) => {}}
                        />

                        <Select
                          label={"Promotion Combo Allowed?"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="combo_allowed"
                          optionsArray={promotionsFormData?.yesno}
                          deactivate={deactivateInputs?.combo_allowed}
                          onChange={(e) => {}}
                        />

                        <Select
                          label={"Promo Combos Allowed Within Group"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="allowed_within_group"
                          optionsArray={promotionsFormData?.yesno}
                          onChange={(e) => {}}
                        />

                        <Select
                          label={"Loyalty-Only Promotion?"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="loyalty_only_promotion"
                          optionsArray={promotionsFormData?.yesno}
                          onChange={(e) => {}}
                        />
                      </ul>
                    </div>

                    <div class="col-md-6">
                      <ul class="ingredient-info edit-shift">
                        <Select
                          label={"Promotion Group"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="promotion_group_id"
                          optionsArray={promotionsFormData?.promotion_group}
                          onChange={(e) => {
                            if (e.target.value === "add_new") {
                              setAddPromoModalState(true);
                            }
                          }}
                        />
                        <Select
                          label={"Promotion Type"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="type"
                          optionsArray={promotionsFormData?.types}
                          onChange={(e) => {
                            switch (e.target.value) {
                              case "2":
                                setValue("combo_allowed", 0);
                                setDeactivateInputs({
                                  ...deactivateInputs,
                                  combo_allowed: true,
                                  qualification_type: false,
                                  auto_apply: false,
                                });
                                break;

                              case "3":
                                setValue("combo_allowed", 0);
                                setDeactivateInputs({
                                  ...deactivateInputs,
                                  combo_allowed: false,
                                  qualification_type: false,
                                  auto_apply: false,
                                });
                                break;

                              case "4":
                                setValue("combo_allowed", 0);
                                setValue("qualification_type", "item");
                                setDeactivateInputs({
                                  ...deactivateInputs,
                                  combo_allowed: true,
                                  qualification_type: true,
                                  auto_apply: false,
                                });
                                break;

                              case "5":
                                setValue("qualification_type", "item");
                                setValue("auto_apply", 0);
                                setDeactivateInputs({
                                  ...deactivateInputs,
                                  combo_allowed: false,
                                  qualification_type: true,
                                  auto_apply: true,
                                });
                                break;

                              default:
                                break;
                            }
                          }}
                        />

                        <Input
                          label={"Amount"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="amount"
                        />
                        <li>
                          <label>Qualification Criteria</label>
                          <button
                            onClick={() => {
                              dispatch(actions.getQualificationCriteria());
                              setQualificationModalState(true);
                            }}
                            type="button"
                            id="submitBut"
                            class="btn green-btn-revert"
                          >
                            Select Items
                          </button>
                          {selectedItemNum} items selected
                        </li>
                        <Input
                          label={"Qualification Criteria"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="amount"
                        />
                        <Select
                          label={"Status"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="status"
                          optionsArray={promotionsFormData?.statuses}
                          onChange={(e) => {}}
                        />

                        <Select
                          label={"Manager Appr Req?"}
                          formRegister={promotionsFormRegister}
                          formError={promotionsFormError}
                          formKey="approval_require"
                          optionsArray={promotionsFormData?.yesno}
                          onChange={(e) => {}}
                        />
                      </ul>
                    </div>
                    <div class="btns d-flex justify-content-end col-12 px-0 my-4">
                      <button id="cancel" type="button">
                        Cancel
                      </button>
                      <button
                        type="button"
                        id="pushBut"
                        class="btn bordered-btn"
                      >
                        Push Updates
                      </button>
                      <button
                        type="submit"
                        id="submitBut"
                        class="btn green-btn-revert"
                      >
                        {" "}
                        Save Changes{" "}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <PeriodTable formType={formType} />
            <AddGroupModal
              addPromoModalState={addPromoModalState}
              setAddPromoModalState={setAddPromoModalState}
              setNewPromotionGroupValue={setNewPromotionGroupValue}
            />
            <QualificationModal
              qualificationModalState={qualificationModalState}
              setQualificationModalState={setQualificationModalState}
              setSelectedItemNum={setSelectedItemNum}
            />
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

const PeriodTable = ({ formType }) => {
  const dispatch = useDispatch();
  const periodTableData = useSelector(
    (state) => state?.settingReducer?.promotionPeriod
  );
  const promotionEditData = useSelector(
    (state) => state?.settingReducer?.promotionEditData
  );
  const showModal = useSelector(
    (state) => state?.settingReducer.promotion_period_modal_state
  );
  const setShowModal = (modalState) =>
    dispatch(
      actions?.setModalState({
        modalName: "promotion_period_modal_state",
        modalState,
      })
    );
  const multiOptions = [
    { value: "", label: "Select All" },
    { value: "Sunday", label: "Sunday " },
    { value: "Monday", label: "Monday " },
    { value: "Tuesday", label: "Tuesday " },
    { value: "Wednesday", label: "Wednesday " },
    { value: "Thursday", label: "Thursday " },
    { value: "Friday", label: "Friday " },
    { value: "Saturday", label: "Saturday " },
  ];
  const [modalType, setModalType] = useState("add");
  const [editModalDefaultState, setEditModalDefaultState] = useState("");

  const [periodStart, setPeriodStart] = useState(null);
  const [periodEnd, setPeriodEnd] = useState(null);
  const [startTime, setStartTime] = useState("00.00");
  const [endTime, setEndTime] = useState("00.00");
  const [days, setDays] = useState("");
  const [publicHoliday, setPublicHoliday] = useState("0");
  const [eveHoliday, setEveHoliday] = useState("0");

  useEffect(() => {
    if (modalType === "add") return;
    console.log("iiiiiiiiiiiiiiiiii", editModalDefaultState);

    setPeriodStart(editModalDefaultState?.period_start);
    setValue("period_start", editModalDefaultState?.period_start);

    setPeriodEnd(editModalDefaultState?.period_end);
    setValue("period_end", editModalDefaultState?.period_end);

    setStartTime(editModalDefaultState?.start_time);
    setValue("start_time", editModalDefaultState?.start_time);

    setEndTime(editModalDefaultState?.end_time);
    setValue("end_time", editModalDefaultState?.end_time);

    setPublicHoliday(editModalDefaultState?.public_holiday?.toString());
    setValue("public_holiday", editModalDefaultState?.public_holiday);

    setEveHoliday(editModalDefaultState?.eve_public_holiday?.toString());
    setValue("eve_public_holiday", editModalDefaultState?.eve_public_holiday);

    const editValueArray = editModalDefaultState?.days;
    setDays(editMultiSelectOptions(multiOptions, editValueArray));
    setValue("days", editValueArray);
  }, [editModalDefaultState, modalType]);

  const addModalDefaultState = {
    period_start: "",
    period_end: "",
    start_time: "",
    end_time: "",
    days: "",
  };
  const modalSchema = yup.object().shape({
    period_start: yup.string().required(),
    period_end: yup.string().required(),
    start_time: yup.string().required(),
    end_time: yup.string().required(),
    days: yup.array().nullable().required(),
  });
  const submitData = (data) => {
    if (formType === "edit") {
      if (modalType === "edit") {
        dispatch(
          actions?.editPromotionPeriod({
            ...data,
            id: editModalDefaultState?.id,
            pos_promotion_id: promotionEditData?.id,
          })
        );
      }
      if (modalType === "add") {
        console.log("uuuuuuuuu", {
          ...data,
          pos_promotion_id: promotionEditData?.id,
        });
        dispatch(
          actions?.editPromotionPeriod({
            ...data,
            pos_promotion_id: promotionEditData?.id,
          })
        );
      }
    } else {
      if (modalType === "edit") {
        dispatch(
          actions?.addPromotionPeriod({
            ...data,
            key: editModalDefaultState?.key,
            // pos_promotion_id: promotionEditData?.id,
          })
        );
      }
      if (modalType === "add") {
        console.log("uuuuuuuuu", {
          ...data,
          pos_promotion_id: promotionEditData?.id,
        });
        dispatch(
          actions?.addPromotionPeriod({
            ...data,
            // pos_promotion_id: promotionEditData?.id,
          })
        );
      }
    }
    console.log(data, "submitData");
  };

  function handleEditModalState(id) {
    const editTableData = periodTableData?.find((el) => el?.id === id);

    setEditModalDefaultState(editTableData);
  }

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(modalSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: modalType ? addModalDefaultState : editModalDefaultState,
  });

  return (
    <>
      <div className="shadowclass mt-0">
        <h4 class="event-alert">
          Applicable Periods and Lifespan Settings
          <div class="clear"></div>
        </h4>

        <div className="table-responsive">
          <table className="checklist-table remove-space ingredTable">
            <thead>
              <tr>
                <th>Period Start</th>
                <th>Period End</th>
                <th>Applicable Time Range</th>
                <th>Applicable Days</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {periodTableData?.map((el) => {
                console.log(periodTableData, "periodTableData");
                return (
                  <tr>
                    <td>{el?.period_start}</td>
                    <td>{el?.period_end}</td>
                    <td>{`${el?.start_time} - ${el?.end_time}`}</td>
                    <td>{el?.days?.join(",")?.replaceAll(",", ", ")}</td>
                    <td>
                      <div class="event-time-edit p0">
                        <a
                          onClick={() => {
                            setShowModal(true);
                            setModalType("edit");
                            handleEditModalState(el?.id);
                          }}
                          class="editPeriodMain"
                        >
                          <i class="iconSprites edit-icon"></i>
                        </a>
                        <a
                          onClick={() => {
                            dispatch(
                              actions?.deletePromotionPeriod({
                                id: el?.id,
                              })
                            );
                          }}
                          class="deletePeriodMain"
                        >
                          <i class="iconSprites delete-icon"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                );
              })}

              <button
                onClick={() => {
                  setShowModal(true);
                  setModalType("add");
                }}
                type="button"
                id="submitBut"
                class="btn green-btn-revert mt-3"
              >
                Add Period
              </button>
            </tbody>
          </table>
        </div>
      </div>
      <ModelContainer
        title="Add Items"
        open={showModal}
        closeModal={() => setShowModal(!showModal)}
        submitModal={handleSubmit(submitData)}
      >
        <form>
          <div className="form-list">
            <ul className="px-0">
              {console.log(errors, "itemModalError")}
              <DateInput
                label={"Period Start"}
                formRegister={register}
                formError={errors}
                formKey="period_start"
                setFormField={setValue}
                dateVal={periodStart}
                setDateVal={setPeriodStart}
              />

              <DateInput
                label={"Period End"}
                formRegister={register}
                formError={errors}
                formKey="period_end"
                setFormField={setValue}
                dateVal={periodEnd}
                setDateVal={setPeriodEnd}
              />

              <TimeInput
                label="Start Time"
                formRegister={register}
                formError={errors}
                formKey={"start_time"}
                timeVal={startTime}
                setTimeVal={setStartTime}
                setFormField={setValue}
              />
              <TimeInput
                label="End Time"
                formRegister={register}
                formError={errors}
                formKey={"end_time"}
                timeVal={endTime}
                setTimeVal={setEndTime}
                setFormField={setValue}
              />
              <MultiSelect
                label={"Days"}
                localStateValue={days}
                setLocalStateMethod={setDays}
                optionsArray={multiOptions}
                formRegister={register}
                formFieldSetMethod={setValue}
                formKey={"days"}
                formError={errors}
              />
              <Checkbox
                label="Public Holiday"
                formRegister={register}
                formError={errors}
                formKey={"public_holiday"}
                checkboxVal={publicHoliday}
                setCheckboxVal={setPublicHoliday}
                checkedValue="1"
                unCheckedValue="0"
                setFormField={setValue}
              />
              <Checkbox
                label="Eve Public Holiday"
                formRegister={register}
                formError={errors}
                formKey={"eve_public_holiday"}
                checkboxVal={eveHoliday}
                setCheckboxVal={setEveHoliday}
                checkedValue="1"
                unCheckedValue="0"
                setFormField={setValue}
              />
            </ul>
          </div>
        </form>
      </ModelContainer>
    </>
  );
};
const AddGroupModal = ({
  addPromoModalState,
  setAddPromoModalState,
  setNewPromotionGroupValue,
}) => {
  // DOCUMENT MODAL START
  const [addApplicationModalInfo, setAddApplicationModalInfo] = useState({
    title: "Add Promo Group",
    modalOpenState: addPromoModalState,
    setModalOpenState: setAddPromoModalState,
    containsFile: false,
    postAddAction: actions.postPromoGroup,
    modalType: "add",
    modalElements: [
      {
        label: "Promo Group",
        elementType: "input",
        modalKey: "name",
        isRequired: "true",
      },
    ],
    editModalState: null,
    postExtraKeys: null,
    runAfterDispatch: function () {
      setNewPromotionGroupValue(true);
    },
  });
  useEffect(() => {
    setAddApplicationModalInfo({
      ...addApplicationModalInfo,
      modalOpenState: addPromoModalState,
      modalType:
        addPromoModalState === false
          ? "add"
          : addApplicationModalInfo.modalType,
    });
  }, [addPromoModalState]);

  // DOCUMENT MODAL END

  return (
    <DynamicModal
      modalInfo={addApplicationModalInfo}
      setModalInfo={setAddApplicationModalInfo}
    />
  );
};
// const QualificationModal = ({
//   qualificationModalState,
//   setQualificationModalState,
//   setSelectedItemNum,
// }) => {
//   const dispatch = useDispatch();
//   const menuDetails = useSelector(
//     (state) =>
//       state?.settingReducer?.promotionQualificationCriteria?.other_category
//   );
//   const promotionEditData = useSelector(
//     (state) => state?.settingReducer?.promotionEditData
//   );
//   const formType = useSelector(
//     (state) => state?.settingReducer?.promo_data_form_type
//   );
//   const [checked, setChecked] = useState([]);
//   const [expanded, setExpanded] = useState([]);
//   const [dataToSubmit, setDataToSubmit] = useState({
//     otherCategories: [],
//     sub_category: [],
//     menu_item_id: [],
//   });
//   const nodes = menuDetails ? JSON.parse(JSON.stringify(menuDetails)) : [];

//   // initialising edit values
//   useEffect(() => {
//     if (formType === "edit" && promotionEditData?.selections) {
//       const initialCheckedBox = [];
//       function initialiseChecked(nodes, searchValue) {
//         for (const item of nodes) {
//           if (searchValue + item?.menu_item_name + item?.key == item?.value) {
//             initialCheckedBox.push(
//               searchValue + item?.menu_item_name + item?.key
//             );
//             break;
//           }
//           for (const el in item) {
//             if (el !== "children" && Array.isArray(item[el])) {
//               initialiseChecked(item[el], searchValue);
//             }
//           }
//         }
//       }
//       const arr = promotionEditData?.selections?.split(",");
//       for (const searchValue of arr) {
//         initialiseChecked(nodes, searchValue);
//       }
//       setChecked(initialCheckedBox);
//     }
//   }, [promotionEditData, formType]);

//   // updating state at every checkbox click
//   useEffect(() => {
//     // const obj = { other_category: 5, sub_category: 10, menu_item: [] };
//     // function getValues(nodes, value) {
//     //   for (const item of nodes) {
//     //     if (item?.value === value && obj[item["parentKey"]]) {
//     //       console.log(obj[item["parentKey"]], item, "bbbbb");
//     //       obj[item["parentKey"]] = [...obj[item["parentKey"]], parseInt(value)];
//     //     }
//     //     for (const el in item) {
//     //       if (el !== "children" && Array.isArray(item[el])) {
//     //         getValues(item[el], value);
//     //       }
//     //     }
//     //   }
//     // }
//     // console.log(checked, "tryyy");
//     // for (const value of checked) {
//     //   getValues(nodes, value);
//     // }
//     // // console.log(obj, "test");
//     // setDataToSubmit(obj);

//     // update selectedItemNum
//     setSelectedItemNum(checked?.length);
//   }, [checked]);

//   // getting nodes in required format
//   function getNodes(newData, parentName) {
//     for (const item of newData) {
//       item["value"] =
//         item.id + (item?.name || item?.menu_item_name) + item?.key;
//       // item["value"] = item?.key;
//       item["label"] = item?.name || item?.menu_item_name;
//       item["parentKey"] = parentName;
//       for (const el in item) {
//         let parentKey = "";
//         if (el !== "children" && Array.isArray(item[el])) parentKey = el;
//         if (Array.isArray(item[el])) {
//           item["children"] = item[el];
//           getNodes(item[el], parentKey);
//         }
//       }
//     }
//   }
//   getNodes(nodes, "other_category");
//   console.log(nodes, "nodes");

//   function postDesiredFormat() {
//     let searchValueArr = [...checked];
//     let res = [];

//     function getDesiredFormat() {
//       let obj = {};
//       nodes?.forEach((otherCat) => {
//         obj["other_category"] = otherCat?.id;

//         otherCat?.sub_category?.forEach((subCat) => {
//           obj["sub_category"] = subCat?.id;

//           subCat?.menu_item?.forEach((menuItem, idx, arr) => {
//             if (searchValueArr?.find((el) => el === menuItem?.value)) {
//               obj["menu_item"] = obj["menu_item"]
//                 ? [...obj["menu_item"], menuItem?.id]
//                 : [menuItem?.id];
//               const index = searchValueArr.indexOf(menuItem?.value);
//               if (index !== -1) {
//                 searchValueArr.splice(index, 1);
//               }
//             }
//             if (obj?.menu_item?.length > 0 && idx === arr?.length - 1) {
//               res.push({ ...obj });
//             }
//           });
//           obj["menu_item"] = null;
//         });
//       });
//     }
//     getDesiredFormat();
//     console.log(res, "resres", searchValueArr);
//     const postData = {
//       criteria: res,
//     };
//     if (formType === "edit") postData["promotion_id"] = promotionEditData?.id;

//     dispatch(actions?.postQualificationCriteria(postData));
//   }

//   const icons = {
//     check: <MdCheckBox className="rct-icon rct-icon-check" />,
//     uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
//     halfCheck: (
//       <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
//     ),
//     expandClose: <MdChevronRight className="rct-icon rct-icon-expand-close" />,
//     expandOpen: (
//       <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />
//     ),
//     expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
//     collapseAll: (
//       <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
//     ),
//     parentClose: <MdFolder className="rct-icon rct-icon-parent-close" />,
//     parentOpen: <MdFolderOpen className="rct-icon rct-icon-parent-open" />,
//     // leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />,
//   };
//   return (
//     <ModelContainer
//       title="
//         Qualification Criteria"
//       open={qualificationModalState}
//       closeModal={() => setQualificationModalState(!qualificationModalState)}
//       submitModal={() => {
//         postDesiredFormat();
//       }}
//     >
//       <form>
//         <h4 className="h4"> Select Menu Items </h4>
//         <div className="form-list">
//           {/* <ul className="px-0">{renderMenuItems(menuDetails)}</ul> */}
//           <ul className="px-0">
//             <CheckboxTree
//               nodes={nodes}
//               checked={checked}
//               expanded={expanded}
//               onCheck={(checked, targetNode) => {
//                 setChecked(checked);
//               }}
//               onExpand={(expanded) => setExpanded(expanded)}
//               icons={icons}
//             />
//           </ul>
//         </div>
//       </form>
//     </ModelContainer>
//   );
// };

const QualificationModal = ({
  qualificationModalState,
  setQualificationModalState,
  setSelectedItemNum,
}) => {
  const dispatch = useDispatch();
  const menuDetails = useSelector(
    (state) =>
      state?.settingReducer?.promotionQualificationCriteria?.other_category
  );
  const promotionEditData = useSelector(
    (state) => state?.settingReducer?.promotionEditData
  );
  const formType = useSelector(
    (state) => state?.settingReducer?.promo_data_form_type
  );
  const [catChecked, setCatChecked] = useState([]);
  const [subCatChecked, setSubCatChecked] = useState([]);
  const [itemChecked, setItemChecked] = useState([]);

  function handleItemChecked(itemId, subCatId) {
    if (itemChecked?.find((id) => id == itemId)) {
      setItemChecked(itemChecked?.filter?.((id) => id !== itemId));
    } else setItemChecked([...itemChecked, itemId]);
  }

  // on the basis of itemChecked
  function shouldSubCatChecked() {
    const tempSubCatArr = [];

    menuDetails?.forEach((cat) => {
      cat?.sub_category?.forEach((subCat) => {
        console.log(
          subCat?.menu_item?.some((item) =>
            itemChecked?.find((el) => el == item?.id)
          )
        );
        if (
          subCat?.menu_item?.some((item) =>
            itemChecked?.find((el) => el == item?.id)
          )
        ) {
          tempSubCatArr?.push(subCat?.id);
        }
      });
    });

    console.log(tempSubCatArr, "tempSubCatArr");
    setSubCatChecked(tempSubCatArr);
  }

  function shouldCatBeChecked() {
    const tempCatArr = [];

    menuDetails?.forEach((cat) => {
      cat?.sub_category?.forEach((subCat) => {
        if (
          subCat?.menu_item?.some((item) =>
            itemChecked?.find((el) => el == item?.id)
          )
        ) {
          tempCatArr?.push(cat?.id);
        }
      });
    });

    console.log(tempCatArr, "tempCatArr");
    setCatChecked(tempCatArr);
  }

  function handleSubCat(subCatId) {
    const targetSubCatItems = [];
    menuDetails?.forEach((cat) => {
      cat?.sub_category?.forEach((subCat) => {
        if (subCat?.id === subCatId) {
          subCat?.menu_item?.forEach((item) => {
            targetSubCatItems.push(item?.id);
          });
        }
      });
    });
    if (subCatChecked?.find((id) => id === subCatId)) {
      const updatedCheckedItem = itemChecked?.filter(
        (item) => !targetSubCatItems?.includes(item)
      );
      setItemChecked(updatedCheckedItem);
    } else {
      setItemChecked([...itemChecked, ...targetSubCatItems]);
    }
  }
  function handleCat(catId) {
    const targetCatItems = [];
    menuDetails?.forEach((cat) => {
      if (cat?.id === catId) {
        cat?.sub_category?.forEach((subCat) => {
          subCat?.menu_item?.forEach((item) => {
            targetCatItems.push(item?.id);
          });
        });
      }
    });
    if (catChecked?.find((id) => id === catId)) {
      const updatedCheckedItem = itemChecked?.filter(
        (item) => !targetCatItems?.includes(item)
      );
      setItemChecked(updatedCheckedItem);
    } else {
      setItemChecked([...itemChecked, ...targetCatItems]);
    }
  }
  useEffect(() => {
    shouldSubCatChecked();
    shouldCatBeChecked();
    setSelectedItemNum(itemChecked?.length);
  }, [itemChecked]);

  useEffect(() => {
    if (formType === "edit") {
      console.log(promotionEditData, "promotionEditData");
      setItemChecked(
        promotionEditData?.selections?.split(",")?.map((el) => +el)
      );
    }
  }, [formType, promotionEditData]);

  function getDesiredFormat() {
    const criteria = [];
    menuDetails?.forEach((cat) => {
      let obj = {};
      cat?.sub_category?.forEach((subCat) => {
        if (subCatChecked?.find((el) => el === subCat?.id)) {
          obj["other_category"] = cat?.id;
          obj["sub_category"] = subCat?.id;

          obj["menu_item"] = subCat?.menu_item
            ?.filter((el) => itemChecked?.includes(el?.id))
            ?.map((el) => el?.id);

          criteria?.push(obj);
          obj = {};
        }
      });
    });
    return criteria;
  }
  console.log(menuDetails, "menuDetails");

  return (
    <ModelContainer
      title="
        Qualification Criteria"
      open={qualificationModalState}
      closeModal={() => setQualificationModalState(!qualificationModalState)}
      submitModal={() => {
        const submitData = {
          promotion_id: formType === "edit" ? promotionEditData?.id : null,
          criteria: getDesiredFormat(),
        };
        dispatch(actions?.postQualificationCriteria(submitData));
      }}
    >
      <form>
        <h4 className="h4"> Select Menu Items </h4>
        <ul className="form-list label-group new-form">
          {menuDetails?.map((cat, idx) => {
            return (
              <div className="checkBoxes">
                <div className="checkbox avaiCheck flex-wrap">
                  <Fragment key={cat?.id.toString()}>
                    <input
                      type="checkbox"
                      className="avail_checkbox"
                      value={0}
                      id={`group_id_${cat?.id}`}
                      onClick={() => handleCat(cat?.id)}
                      checked={
                        catChecked.find((el) => el == cat?.id) ? true : false
                      }
                    />
                    <label for={`group_id_${cat?.id}`}>{cat?.name}</label>

                    <a
                      class="link"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`.account-multi-collapse-${cat?.id}`}
                      aria-expanded="false"
                      aria-controls={`account-collapse-${cat?.id}`}
                    >
                      {" "}
                      <i className="btn dropdown" />{" "}
                    </a>
                    <div
                      id={`account-collapse-${cat?.id}`}
                      className={`group-collapse inner-checkbox collapse account-multi-collapse-${cat?.id}`}
                    >
                      {cat?.sub_category?.map((subCat, idx) => {
                        return (
                          <div class="groupSec">
                            <div className="checkbox avaiCheck flex-wrap">
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={true}
                                id={`cluster_id_${subCat?.id}`}
                                onClick={() => handleSubCat(subCat?.id)}
                                checked={
                                  subCatChecked.find((el) => el == subCat?.id)
                                    ? true
                                    : false
                                }
                              />
                              <label for={`cluster_id_${subCat?.id}`}>
                                {subCat?.name}
                              </label>
                              <>
                                <a
                                  class="link"
                                  role="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`.cluster-multi-collapse-${subCat?.id}`}
                                  aria-expanded="false"
                                  aria-controls={`cluster-collapse-${subCat?.id}`}
                                >
                                  {" "}
                                  <i className="btn dropdown" />{" "}
                                </a>
                                {subCat?.menu_item?.map((item) => {
                                  return (
                                    <div
                                      class={`pt-3 collapse inner-checkbox cluster-multi-collapse-${subCat?.id}`}
                                      id={`cluster-collapse-${subCat?.id}`}
                                    >
                                      <div className="checkbox avaiCheck">
                                        <input
                                          type="checkbox"
                                          className="avail_checkbox"
                                          value={true}
                                          id={`store_id_${item?.id}`}
                                          onClick={() =>
                                            handleItemChecked(
                                              item?.id,
                                              subCat?.id
                                            )
                                          }
                                          checked={
                                            itemChecked?.find(
                                              (el) => el == item?.id
                                            )
                                              ? true
                                              : false
                                          }
                                        />
                                        <label for={`store_id_${item?.id}`}>
                                          {item?.menu_item_name}
                                        </label>
                                      </div>
                                    </div>
                                  );
                                })}
                              </>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Fragment>
                </div>
              </div>
            );
          })}
        </ul>
      </form>
    </ModelContainer>
  );
};
export default NewPromotion;
